import { useEffect, useState } from "react";
import { eventConfig } from "@/config/eventConfig";
import { captureAttribution, getReferralCode, getVisitorId } from "@/lib/attribution";
import { initAnalytics, analytics } from "@/lib/analytics";
import { trackVisit } from "@/lib/registrationService";

import Header from "@/components/sections/Header";
import MobileBottomCTA from "@/components/sections/MobileBottomCTA";
import HeroHeader from "@/components/sections/HeroHeader";
import VideoIntro from "@/components/sections/VideoIntro";
import CpfClarityExplorer from "@/components/sections/CpfClarityExplorer";
// Video highlights (PastEventStories) and the Reviews carousel (SampleTestimonials)
// are temporarily replaced by written AttendeeStories pending CPF Board approval.
import AttendeeStories from "@/components/sections/AttendeeStories";
import RegistrationModal from "@/components/sections/RegistrationModal";
import Agenda from "@/components/sections/Agenda";
import Speakers from "@/components/sections/Speakers";
import Registration from "@/components/sections/Registration";
import Faq from "@/components/sections/Faq";
import FinalCta from "@/components/sections/FinalCta";
import Footer from "@/components/sections/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

// Record a visit for per-link traffic analytics (clicks + unique visitors).
function recordLandingVisit() {
  const attr = captureAttribution();
  trackVisit({
    referral_code: getReferralCode(),
    visitor_id: getVisitorId(),
    event_id: eventConfig.eventId,
    landing_page_url: window.location.href,
    referrer: document.referrer,
    utm_source: attr.utm_source || "",
  });
}

export default function LandingPage() {
  const [regOpen, setRegOpen] = useState(false);

  // Runs once on mount. Everything referenced here is a module-level import
  // (stable identity), so the empty dependency array is intentional.
  useEffect(() => {
    document.title = eventConfig.seo.title;
    initAnalytics();
    analytics.pageView({ event_id: eventConfig.eventId });
    recordLandingVisit();
  }, []);

  const scrollToRegister = (source) => {
    analytics.primaryCtaClick({ source });
    const el = document.getElementById("register");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const openRegistrationModal = () => setRegOpen(true);

  return (
    <>
      <Header onRegister={() => scrollToRegister("header")} />
      <main>
        <HeroHeader onRegister={openRegistrationModal} />
        <VideoIntro onRegister={openRegistrationModal} />
        <CpfClarityExplorer onRegister={openRegistrationModal} />
        <AttendeeStories onRegister={openRegistrationModal} />
        <Agenda />
        <Speakers />
        <Registration />
        <Faq />
        <FinalCta onRegister={() => scrollToRegister("final-cta")} />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <MobileBottomCTA onRegister={() => scrollToRegister("mobile-bottom")} />
      <RegistrationModal open={regOpen} onOpenChange={setRegOpen} />
    </>
  );
}
